export const MAX_EXTERNAL_SCRIPT_CHARS = 200000;
export const MAX_BREAKDOWN_CHARS = 8000;
export const MAX_SCRIPT_FILE_BYTES = 5 * 1024 * 1024;

function normalizeEpisodeNumber(value) {
  const digits = { 零: 0, 〇: 0, 一: 1, 二: 2, 两: 2, 三: 3, 四: 4, 五: 5, 六: 6, 七: 7, 八: 8, 九: 9 };
  const number = value.normalize('NFKC').replace(/[零〇一二两三四五六七八九]/g, digit => digits[digit]);
  if (/^\d+$/.test(number)) return number.replace(/^0+(?=\d)/, '');
  let total = 0;
  let pending = 0;
  for (const char of number) {
    if (char === '十' || char === '百') {
      total += (pending || 1) * (char === '百' ? 100 : 10);
      pending = 0;
    } else {
      pending = pending * 10 + Number(char);
    }
  }
  return String(total + pending);
}

export function splitExternalScript(value) {
  const text = String(value || '').replace(/^\uFEFF/, '').replace(/\r\n?/g, '\n').trim();
  const headings = [...text.matchAll(/^[ \t]*(?:#{1,3}[ \t]*)?第[ \t]*([0-9０-９一二三四五六七八九十百零〇两]+)[ \t]*集([ \t　:：、.．—-]+[^\n]*)?[ \t]*$/gm)];
  const grouped = new Map();
  headings.forEach((match, index) => {
    const id = `episode-${normalizeEpisodeNumber(match[1])}`;
    const title = match[0].trim().replace(/^#{1,3}\s*/, '');
    const hasName = Boolean((match[2] || '').replace(/^[ \t　:：、.．—-]+/, '').trim());
    const episode = grouped.get(id) || { id, title, hasName, chunks: [] };
    if (hasName && !episode.hasName) { episode.title = title; episode.hasName = true; }
    // A contents entry or repeated page heading belongs to the same episode; keep every body segment.
    episode.chunks.push(text.slice(match.index, headings[index + 1]?.index ?? text.length).trim());
    grouped.set(id, episode);
  });
  const episodes = [...grouped.values()].map(({ id, title, chunks }) => ({ id, title, content: chunks.join('\n\n') }));
  return { text, episodes, preamble: headings.length ? text.slice(0, headings[0].index).trim() : '' };
}

export function externalScriptSelection(draft) {
  const parsed = splitExternalScript(draft.text);
  const episode = parsed.episodes.find(item => item.id === draft.selectedId);
  const multiple = parsed.episodes.length > 1;
  return { ...parsed, multiple, selectedEpisode: episode,
    content: multiple ? episode ? [parsed.preamble, episode.content].filter(Boolean).join('\n\n') : '' : parsed.text,
    episodeLabel: multiple ? episode?.title || '' : parsed.episodes[0]?.title || '',
  };
}

export async function readScriptTextFile(file) {
  const buffer = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('文件读取失败，请重新选择。'));
    reader.readAsArrayBuffer(file);
  });
  const bytes = new Uint8Array(buffer);
  let encoding = bytes[0] === 0xff && bytes[1] === 0xfe ? 'utf-16le' : bytes[0] === 0xfe && bytes[1] === 0xff ? 'utf-16be' : 'utf-8';
  let text;
  try { text = new TextDecoder(encoding, { fatal: true }).decode(bytes); }
  catch { text = new TextDecoder('gb18030', { fatal: true }).decode(bytes); }
  if (text.includes('\0')) throw new Error('这个文件不像纯文本剧本，请另存为 TXT 后重试。');
  return text.replace(/^\uFEFF/, '').replace(/\r\n?/g, '\n').trim();
}
